import { render, staticRenderFns } from "./MyLink.vue?vue&type=template&id=371f3e51&"
import script from "./MyLink.vue?vue&type=script&lang=js&"
export * from "./MyLink.vue?vue&type=script&lang=js&"
import style0 from "./MyLink.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports